import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";

export const fetchOrder = async (data) => {
  const res = await api.get(API_ROUTES.ORDER.LIST, {
    params: { ...data },
  });
  return res.data;
};
export const fetchOrderStatus = async (data) => {
  const res = await api.get(API_ROUTES.ORDER.STATUS, {
    params: { ...data },
  });
  return res.data;
};
export const createOrder = async (data) => {
  const res = await api.post(API_ROUTES.ORDER.CREATE, data);
  return res.data;
};
export const fetchOrderDetails = async (data) => {
  const res = await api.post(API_ROUTES.ORDER.INFO, data);
  return res.data;
};
export const deleteOrderApi = async (data) => {
  const { _id } = data;
  const res = await api.delete(API_ROUTES.ORDER.DELETE(_id));
  return res.data;
};
export const deleteOrderItemApi = async (data) => {
  const { _id } = data;
  const res = await api.delete(API_ROUTES.ORDER.DELETE_ITEM(_id));
  return res.data;
};

// 🔹 change status
export const changeOrderStatusApi = async (data) => {
  const { _id, ...payload } = data;
  const res = await api.put(API_ROUTES.ORDER.CHANGE_STATUS(_id), payload);
  return res.data;
};

export const splitOrderItemApi = async (data) => {
  const res = await api.post(API_ROUTES.ORDER.SPLIT_ITEM, data);
  return res.data;
};

export const reverseSplitOrderItemApi = async (data) => {
  const res = await api.post(API_ROUTES.ORDER.REVERSE_SPLIT_ITEM, data);
  return res.data;
};

// 🔹 update item
export const updateOrderItemApi = async (data) => {
  const { _id, ...payload } = data;
  const res = await api.put(API_ROUTES.ORDER.EDIT_ITEM(_id), payload);
  return res.data;
};
